var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAt = function SvgAt(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 48,
    viewBox: "0 0 74 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9019 0.772461L17.3203 28.8276L31.8913 20.6579L35.4784 13.3403C39.2568 22.9775 46.8135 42.1516 46.8135 41.7498C46.8135 41.348 55.3268 41.5824 59.5834 41.7498L43.0112 0.772461H27.9019Z",
    fill: "#00346A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97953 23.8851H0.403748L11.403 47.5544L73.5698 5.99383V2.7915L15.9977 34.0489L2.97953 23.8851Z",
    fill: "#DF0000"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AT.9a6beb98.svg";
export { ForwardRef as ReactComponent };